<template>
  <div>
    <div class="container">
      <e-search
        :data="query"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      ></e-search>
    </div>
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="secondary" @click="addSalesScope">
          新增销售区域
        </eui-btn>
      </div>

      <eTableList :table-data="tableData" :table-label="tableLabel" :index-show="true">
        <template #handle="{scope}">
          <span
            class="table-handle-btn"
            v-if="scope.row.salesScopeId !== -1"
            @click="editScope(scope.row)"
          >
            编辑
          </span>
          <span
            class="table-handle-btn"
            v-if="scope.row.salesScopeId !== -1"
            @click="deleteScope(scope.row)"
          >
            删除
          </span>
          <span
            class="table-handle-btn"
            v-if="scope.row.salesScopeId !== -1"
            @click="checkScope(scope.row)"
          >
            查看
          </span>
        </template>
      </eTableList>

      <!-- <el-table :data="tableData" border v-loading="tableLoading">
        <el-table-column fixed label="序号" type="index" min-width="50">
          <template slot-scope="scope">
            <span>{{ (query.pageNum - 1) * query.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in bindTableColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
        ></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.salesScopeId !== -1"
              type="text"
              @click="editScope(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="scope.row.salesScopeId !== -1"
              type="text"
              @click="deleteScope(scope.row)"
            >
              删除
            </el-button>
            <el-button
              v-if="scope.row.salesScopeId !== -1"
              type="text"
              @click="checkScope(scope.row)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table> -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="query.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <AddSalesTerritory
      ref="addDialog"
      :title="title"
      :form="form"
      :visible="dialogVisible"
      @cancel="handleCancel"
      @save="saveEdit"
    ></AddSalesTerritory>
  </div>
</template>

<script>
import eSearch from '../../components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import api from '../../api/product';
import AddSalesTerritory from '../../pages/product/addSalesTerritory';
export default {
  name: 'salesTerritoryManage',
  components: { eSearch, AddSalesTerritory, eTableList },
  props: {},
  data() {
    return {
      tableLoading: false,
      query: {
        salesScopeName: '',
        pageNum: 1,
        pageSize: 10,
      },
      tableLabel: [
        {
          label: '销售区域名称',
          param: 'salesScopeName',
          align: 'center',
          minWidth: 140,
        },
        {
          label: '操作',
          align: 'center',
          width: 180,
          slot: 'handle',
        },
      ],
      fieldList: [{ label: '销售区域名称', type: 'input', value: 'salesScopeName' }],
      listTypeInfo: {},
      tableColumns: [{ prop: 'salesScopeName', label: '销售区域名称', show: true }],
      tableData: [],
      pageTotal: 0,
      title: '',
      param: {
        salesScopeName: '',
        salesScopeId: '',
        expandKeys: [],
        checkedKeys: [],
      },
      form: {},
      dialogVisible: false,
    };
  },
  computed: {
    bindTableColumns() {
      return this.tableColumns.filter(column => column.show);
    },
    /* 这里使用了getter和setter，这样写的好处不用自己手动监听复选框的选中事件 */
    checkedTableColumns: {
      get() {
        // 返回选中的列名
        return this.bindTableColumns.map(column => column.prop);
      },
      set(checked) {
        // 设置表格列的显示与隐藏
        this.tableColumns.forEach(column => {
          // 如果选中，则设置列显示
          if (checked.includes(column.prop)) {
            column.show = true;
          } else {
            // 如果未选中，则设置列隐藏
            column.show = false;
          }
        });
      },
    },
  },
  created() {
    this.getData();
  },
  methods: {
    handleSearch(val) {
      this.query.salesScopeName = val.salesScopeName;
      this.query.pageNum = 1;
      this.getData();
    },
    handleClear() {
      this.query.salesScopeName = '';
      this.query.pageNum = 1;
      this.query.pageSize = 10;
      this.getData();
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageNum', val);
      this.getData();
    },
    getData() {
      this.tableLoading = true;
      api.getSalesScopePage(this.query).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.pageTotal = res.data.total;
        }
      });
    },
    editScope(row) {
      this.title = '编辑';
      this.param = row;
      this.$refs.addDialog.setDisabledFlag(false);
      this.$refs.addDialog.assembleTreeData();
      this.$refs.addDialog.setChecked(this.param);
      this.dialogVisible = true;
    },
    deleteScope(row) {
      api.salesScopeDelete({ salesScopeId: row.salesScopeId }).then(res => {
        if ('success' === res.data) {
          this.$message({
            showClose: true,
            message: '删除销售区域成功',
            type: 'success',
          });
          this.getData();
        }
      });
    },
    checkScope(row) {
      this.title = '查看';
      this.$refs.addDialog.setDisabledFlag(true);
      this.param = row;
      this.$refs.addDialog.assembleTreeData();
      this.$refs.addDialog.setChecked(this.param);
      this.dialogVisible = true;
    },
    addSalesScope() {
      this.title = '新增';
      this.form = {};
      this.$refs.addDialog.setDisabledFlag(false);
      this.$refs.addDialog.assembleTreeData();
      this.$refs.addDialog.handleClear();
      this.dialogVisible = true;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    saveEdit(val) {
      for (let i = 0; i < val.result.length; i++) {
        for (let j = 0; j < val.checkedKeys.length; j++) {
          if (val.checkedKeys[j] === val.result[i].areaCode) {
            val.result[i].isSale = 1;
          }
        }
      }
      if ('新增' === this.title) {
        console.log(val);
        console.log(val.result);
        let addParams = {};
        addParams.salesScopeName = val.salesScopeName;
        addParams.salesScopeAreas = val.result;
        api.addSalesScope(addParams).then(res => {
          if ('success' === res.data) {
            this.dialogVisible = false;
            this.$message({
              showClose: true,
              message: '新增销售区域成功',
              type: 'success',
            });
            this.getData();
          }
        });
      } else if ('编辑' === this.title) {
        let editParam = {};
        editParam.salesScopeName = val.salesScopeName;
        editParam.salesScopeId = val.salesScopeId;
        editParam.salesScopeAreas = val.result;
        console.log(editParam);
        api.editeSalesScope(editParam).then(res => {
          if ('success' === res.data) {
            this.dialogVisible = false;
            this.$message({
              showClose: true,
              message: '编辑销售区域成功',
              type: 'success',
            });
            this.getData();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  text-align: right;
}
</style>
